import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/vaccine-solution-main/vaccine-solution-main/docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Cloud Pak For Data is the Data and AI platform which can be used to dvelop model for any kind of Anomaly detection in the Refrigerated Container based on the event generated by the sensors in the container.`}</p>
    <p>{`To detect any kind of Anomaly in the Refrigeration Container an Anomaly detection model can be generated using Cloud Pak for Data. Cloud Pak for Data various components those can be used for that purpose.`}</p>
    <p>{`In Cloud Pak For Data a Predictive Model can be created based on the process depicted in the diagram below.`}</p>
    <p>{` `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "50.34722222222222%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABcSAAAXEgFnn9JSAAAC00lEQVQoz42QW0hTcRzHT41TL0XENs9UcmhRVNRbrz2UEMKiYRH4FBJGSm+NsttLdrEkt4zQLopT8xJqMzPzVtFllU1d8zpvO7udnLaLHl36n//z7UyCXvvDh++H/w++/z8/RqFQcBrVVm2CWpXKqZWpauXW7dvT0tRJiRqtRsNpkzlVilqlSkvSJKQkJii1CRynTU1J1gBYNzZsV8D7UREMeBTSyrxCvmPWTlz+j/l/HuqS08dgwcJgZUz2OWY1Xmifxybyc6pAFKP3V8VwcSQwY4xEJSONicbfS7+MmO03RoPTRkRkhH7jfEiQ3WkMuh2mcMhvWuZ7TYJ32jQbmCkZ9//m4q8ltjY1xooeVuDJk3JY6qvx/EU7zC8nUVQzgZJ6J241B1H0IoBSiwuFbSLqOwW87PLA3BHBm/dTaLQG8dUpIraytC9eyGWcMvxcv+0ANu86uKLTnyC6o8fJ7szXRJnhIMyJCGGyQZhMkC3nseYbckDOlICkXwbRm0CyzSBXmiUpMBfaHS/U1La0z90uLYepoorWNtSgrrEJD5t5FDfO4rplGYWdwM03QPE74O5b4PEHoNMONH8DWn9AstglyTpOIC5E9sQXqRbnpIB7UIR3aJGOD4Sl0b4Z6rR56YTdR4URH/U4PNQ35JHTTSdtLurqd8lznk7289TZ66LLkQUKxDDGyz9smajY0WZtEavqG1D5vIa+et0FxxcPBj7zGOz1YqjPj0Gbfy0d330YsLph+8Tj09spfH7nwsfuKfB8GOHFZYxMB/cyuVVHDudWZeBctZ6eMaej8ntBVF6DnyAmxEAFIq0KMRnyF3km+EOiUNbmFB69GhYet40I9xrs/qeto4HWr8JOJs+sO5RTegynH+iJDHIrdHX6SoY5e6FsoyG/g710rYe9eLmbzb/awxryu1iDoYPNzKpjGc0dlmHSZU6y6v15bNaFcvbGs3HmDyDHJAiylgogAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "1",
          "title": "1",
          "src": "/vaccine-solution-main/static/1e357e682cf4b18c24183a89c989cc41/3cbba/ModelOps-2.png",
          "srcSet": ["/vaccine-solution-main/static/1e357e682cf4b18c24183a89c989cc41/7fc1e/ModelOps-2.png 288w", "/vaccine-solution-main/static/1e357e682cf4b18c24183a89c989cc41/a5df1/ModelOps-2.png 576w", "/vaccine-solution-main/static/1e357e682cf4b18c24183a89c989cc41/3cbba/ModelOps-2.png 1152w", "/vaccine-solution-main/static/1e357e682cf4b18c24183a89c989cc41/0b124/ModelOps-2.png 1728w", "/vaccine-solution-main/static/1e357e682cf4b18c24183a89c989cc41/4f96e/ModelOps-2.png 2027w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`Different components of Cloud Pak For Data can be used to implement the above process as shown in the diagram below.`}</p>
    <p>{` `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "55.208333333333336%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABcSAAAXEgFnn9JSAAADd0lEQVQozx2Qa0xTdxiH/zIyEpN92bctW9SwbFxtnYplgczL0A/LnGZMM1miiSZetiVjI0t0CAKzzLAFw2WK2NLh7KSX9EZbKKc9Pe05bWk5PZSWlkopUjgVy+lc5pDuQ8+7A2/yyy9v3uTJmwcVFha+XlRU9FZBwbY3EUJvVIr27Th56mzFXslB0YGaunJJ7dHyE/UNFR+fvvI2O6XfxXqUB5cdCvG8eaAsOtL97vzo3ZLHur7dK87hAyveR7UIALbyfWPbK3+nU4hmIr/QwdC/TheVmrA700JYfyDIMeHHzCI9Ls3aZeRTwx1TRtdrzhj7MW58EHtulxNZ233/quuBHbHrqVc3gRbPguSOZnbO4FpKD2iC2d6HHm5Qy3AK0yzXp/Rme5T+zJgvPW+cfDYXt4bCnNrty+IzNGmjZA+05m7TBHlhk4MSz+LfJdfm/puMxlRNXdaXI1gSelRRkMp8IL1PwS2Ff6u7/giDnliCXnUIQuZpSBk8fNoVAcrhD8tHzA6dleq80XUVIXou0ubwUuBmYhapPJBR2ZPws9ybF4D8VuQ+XoDyLf04P2KL57uHCcBw9oUHW5kPeFYX7c7w3aE/Dde0ZncD2pzJ8EyzFXeCKxgz3lZOc2rHE7j1e5BvG6Cg/Z4H2oXuEPpaDw6bt9vDLl6DcWAgXoKT3gCMjLuUWrPCaPM2NXzxGUL+SKgdo0gg6OjYVzc0a0PGiABk8tf7CeErgv+xBxPgJN/cT/Iq7En+VxkGRge7bsG5JEU/X3H7Ei0ype64ftxb01lfi5Dg79LSX7FlJplQKMYSL4y+p4KvAHQMEnBTToF0yAM/3SOgQ/CoJlLQZ4iCcXQBTIJTt20BCHxa91BrajFPeL+sO9OM0FqGLZS34ijkjUsWmEV2NpBkSSLGWtV+1jCIs6ZhkrXoQiw2SrNTrhg7bppZdRhCMb1qBiMcCfKRzqf+TWFWKjR402tH9NvRBELbwofr0FRxebV/Z+lGoESUi5w4tRGtP5NjKvfn6BJxLlLfkIsc/zzHfHBoPVgmBmbnO+odnw7Iy072/vPRxfals9cbly/fvJw+3/ptGn1yrK6gqnI3OlRdXSMRi2FPSelWqkRiqBL2vaVlICouhg8lEjh2+Aj/fnkF7HmvdLTmXLfl6MVOOP3DVbjU8Q183XkFzrc25v8H3Kk49mgDfj4AAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "1",
          "title": "1",
          "src": "/vaccine-solution-main/static/b35f71fde74f621a87216198359793cc/3cbba/ModelOpsUsingCPD.png",
          "srcSet": ["/vaccine-solution-main/static/b35f71fde74f621a87216198359793cc/7fc1e/ModelOpsUsingCPD.png 288w", "/vaccine-solution-main/static/b35f71fde74f621a87216198359793cc/a5df1/ModelOpsUsingCPD.png 576w", "/vaccine-solution-main/static/b35f71fde74f621a87216198359793cc/3cbba/ModelOpsUsingCPD.png 1152w", "/vaccine-solution-main/static/b35f71fde74f621a87216198359793cc/0b124/ModelOpsUsingCPD.png 1728w", "/vaccine-solution-main/static/b35f71fde74f621a87216198359793cc/a610d/ModelOpsUsingCPD.png 2012w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{` Useing the components shown in the above diagram Anomaly Detection model for Refrigerated Container can be developed. Tho details of the same would be covered in the subsequent sections.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      